import { defineMessage } from 'services/localization';

export const messages = {
    emailRequired: defineMessage('enter_your_email'),
    emailInvalid: defineMessage('the_email_address_is_not_valid_1'),
    emailPlaceholder: defineMessage('enter_your_email_address'),
    email: defineMessage('enter_your_business_email'),
    agreement: defineMessage('i_agree_to_receive_appr_ghts_and_special_offers'),
    submitButton: defineMessage('sign_up_for_free'),
};
